import React, { Component } from 'react'
import $ from 'jquery'

import images from '../../../config/images'
import '../../../stylesheets/programs.css'

class Programs extends Component {
	componentDidMount() {
		scrollUpdate()

		$(window).scroll(function () {
			scrollUpdate()
		})

		function scrollUpdate() {
			if ($('#PROGRAMS_PAGE').length) {
				//Window Variables
				var windowTop = $(window).scrollTop()
				var windowHeight = $(window).height()
				var windowBottom = windowTop + windowHeight

				//Header Text
				var news = $('#giving')
				var newsBottom = news.offset().top + news.outerHeight() * 0.5

				if (windowBottom > newsBottom) {
					news.addClass('fade-in')
				}

				//scholarship
				var scholarship = $('#scholarship')
				var scholarshipBottom = scholarship.offset().top + scholarship.outerHeight() * 0.5

				if (windowBottom > scholarshipBottom) {
					scholarship.addClass('fade-in')
				}

				//equipment
				var equipment = $('#equipment')
				var equipmentBottom = equipment.offset().top + equipment.outerHeight() * 0.5

				if (windowBottom > equipmentBottom) {
					equipment.addClass('fade-in')
				}
			}
		}
	}

	render() {
		return (
			<div id='PROGRAMS_PAGE'>
				{/* Content */}
				<header className='header' id='header'>
					<img
						src={images.programs_header}
						alt='background'
						width='100%'
						height='100%'
						className='header-img'
					/>
					<h1 className='header-txt' id='giving'>
						GIVING BACK
					</h1>
				</header>
				<div className='section scholarship' id='scholarship'>
					<div className='title'>
						<img
							src={images.rpfpc_graduation_photo}
							alt='background'
							className='background'
						/>
						<h2>ACADEMIC SCHOLARSHIP PROGRAM</h2>
						<div className='copy mobile'>
							<div className='dash-container'>
								<div className='underline' />
							</div>
							<p>
								RPFPC's Scholarship Program provides high school student-athletes
								(one male and one female) with financial support as he/she pursues
								education at a collegiate institution that does not offer athletic
								scholarships. The RPFPC Scholarship is annually awarded to deserving
								individuals who have demonstrated academic success and outstanding
								character throughout their high school careers. Scholarship
								recipients are also honored each year at RPFPC's Annual Celebrity
								Golf Outing, with a special recognition at the event's reception.
							</p>
							<p>
								To apply for the scholarship, click below. Please download, complete
								and return the required documents to our office.
							</p>
							{/* <p>*Applications for 2017  is now CLOSED .</p> */}
							<a
								href={
									images.pdfs
										.paf_scholarship_package_2018_chicago_chapter_criteria_application
								}
								target='_blank'
								rel='noopener noreferrer'
								className='button'
							>
								Scholarship Application
							</a>
						</div>
					</div>
					<div className='copy'>
						<div className='dash-container'>
							<div className='underline' />
						</div>
						<p>
							RPFPC's Scholarship Program provides high school student-athletes (one
							male and one female) with financial support as he/she pursues education
							at a collegiate institution that does not offer athletic scholarships.
							The RPFPC Scholarship is annually awarded to deserving individuals who
							have demonstrated academic success and outstanding character throughout
							their high school careers. Scholarship recipients are also honored each
							year at RPFPC's Annual Celebrity Golf Outing, with a special recognition
							at the event's reception.
						</p>
						<p>
							To apply for the scholarship, click below. Please download, complete and
							return the required documents to our office.
						</p>
						{/* <p>*Applications for 2017  is now CLOSED .</p> */}
						<a
							href={
								images.pdfs
									.paf_scholarship_package_2018_chicago_chapter_criteria_application
							}
							target='_blank'
							rel='noopener noreferrer'
							className='button'
						>
							Scholarship Application
						</a>
					</div>
				</div>
				<div className='section equipment' id='equipment'>
					<div className='copy'>
						<div className='dash-container'>
							<div className='underline' />
						</div>
						<p>
							RPFPC's Football Equipment Grant Program provides local youth football
							leagues with safe and proper playing gear. The grant is annually awarded
							to four youth or high school football programs that are in need of new
							equipment. Each program is eligible to receive $3,500.00 towards the
							purchase of new equipment. Grants are awarded based on need, which must
							be demonstrated in the application.
						</p>
						<p>
							To apply for the grant, click below. Please download, complete and
							return the required documents to our office by the listed deadline.
						</p>
						{/* <p>
							*The deadline for the Applications for the 2020 youth football grant are
							now complete. Thank you for all your entries.
						</p> */}
						<p>
							*Applications for the 2021 season must be received and accepted no later
							than June 25th, 2021. For further information, please email{' '}
							<a href='mailto:tserpento17@hotmail.com'>Tom Serpento</a>.
						</p>
						<a
							href={images.pdfs['RPFPC-Youth-Football-Grant-Application-2021']}
							target='_blank'
							rel='noopener noreferrer'
							className='button'
						>
							Grant Application
						</a>
					</div>
					<div className='title'>
						<img
							src={images.football_equipment_image}
							alt='background'
							className='background'
						/>
						<h2>FOOTBALL EQUIPMENT GRANT PROGRAM</h2>
						<div className='copy mobile'>
							<div className='dash-container'>
								<div className='underline' />
							</div>
							<p>
								RPFPC's Football Equipment Grant Program provides local youth
								football leagues with safe and proper playing gear. The grant is
								annually awarded to four youth or high school football programs that
								are in need of new equipment. Each program is eligible to receive
								$3,500.00 towards the purchase of new equipment. Grants are awarded
								based on need, which must be demonstrated in the application.
							</p>
							<p>
								To apply for the grant, click below. Please download, complete and
								return the required documents to our office by the listed deadline.
							</p>
							{/* <p>
								*The deadline for the Applications for the 2020 youth football grant
								are now complete. Thank you for all your entries.
							</p> */}
							<p>
								*Applications for the 2021 season must be received and accepted no
								later than June 25th, 2021. For further information, please email{' '}
								<a href='mailto:tserpento17@hotmail.com'>Tom Serpento</a>.
							</p>
							<a
								href={images.pdfs['RPFPC-Youth-Football-Grant-Application-2021']}
								target='_blank'
								rel='noopener noreferrer'
								className='button'
							>
								Grant Application
							</a>
						</div>
					</div>
				</div>
				<div className='contact'>
					<p>
						For more information or assistance with your application, please contact the
						<a href='mailto:ProgramDirector@rpfpc.com'>Program Director</a>.
					</p>
				</div>
			</div>
		)
	}
}

export default Programs
